export const checkbox = (value?: boolean) => ({
  error: false,
  checked: value || false,
  toggle() {
    this.checked = !this.checked;
    this.$refs.input.checked = this.checked;
    this.validate();
  },
  validate() {
    this.error = !this.$refs.input.checkValidity();
  },
  onInvalid(event) {
    event.preventDefault();
    this.error = true;
  },
  init() {
    this.$refs.input.checked = this.checked;
  },
});
